const cn = {
  menu: {
    about: { title: "About Us" },
    products: {
      title: "Products",
      tea: "Tea",
      coffee: "Coffee",
      agricultural: "Agricultural",
      energyDrink: "Energy Drink",
      juice: "Guava Juice",
      oil: "Cooking Oil",
    },
    promotion: { title: "Promotions" },
    news: {
      title: "News",
      newsTea: "Tea news",
      newsCoffee: "Coffee news",
      newsAgri: "Agricultural news",
    },
    noidia: { title: "Domestic" },
    xuatkhau: { title: "Export" },
    recruitment: { title: "Jobs" },
    muahang: { title: "Purchase" },
    contact: { title: "Contact" },
    search: { title: "Search" },
    profile: { title: "Profile" },
    language: { title: "Language" },
  },
  footer: {
    addressLabel: "Address",
    customerPolicy: "CUSTOMER POLICY",
    contactInfo: "Contact Info",
    factory: "FACTORY ADDRESS",
    followUs: "FOLLOW US",
    contactWith: "CONNECT WITH VIET THIEN",
    payments: "Payment methods",
    cod: "COD",
    bankTransfer: "Bank transfer",
    wallet: "Electronic wallet",
    info1:
      "Business Certificate Number: 0305693542 – Issued on Febuary 22, 2008",
    info2: "By the Department of Planning and Investment of HCM City.",
    menu: "网站目录",
    about: "关于我们",
    operation: "经营领域",
    news: "新闻动态",
    contact: "联系方式",
    recruitment: "人才招聘",
    policy: "使用条款",
    workingtime: "工作时间",
    time1: "周一至周五: 08:00 - 17:00",
    time2: "周六: 08:00 - 12:00",
    connect: "关注我们",
    companyName: "玉东方投资贸易股份有限公司",
  },
  contact: {
    content:
      "If you have any concern or wish to cooperate, please leave your information, we will assist you as soon as possible.",
    taxCodeLabel: "Tax code",
    email: "Email",
    address: "Office",
    form: {
      title: "Contact us",
      fullName: "Name",
      email: "Email",
      phone: "Phone number",
      address: "Address",
      content: "Comments",
      button: "Submit",
      loading: "Sending...",
    },
    placeholder: {
      fullName: "Your name",
      email: "Your email address",
      phone: "Your phone number",
      content: "Enter a comment here...",
      address: "Your address",
    },
    toast: {
      success: "Your information has been sent successfully.",
      error: "Failed to send information. Please try again later.",
    },
    map: {
      title: "List of Viet Thien factories",
    },
  },
  news_flow: {
    latest_update: "最新动态",
    title: "新闻与活动",
    view_all: "查看全部",
    read_more: "阅读更多",
    back_to_list: "返回列表",
    editorial_board: "西北德和东工业园管理委员会",
    share: "分享",
    related_news: "相关新闻",
    search_placeholder: "搜索新闻...",
    no_results: "未找到相关新闻。",
    categories: {
      all: "全部",
      company: "工业园动态",
      market: "市场资讯",
      product: "产品",
      event: "活动",
    },
    blog_title: "新闻与活动",
    blog_subtitle1: "来自西北德和东工业园的",
    blog_subtitle2: "最新动态",
    blog_desc:
      "了解西北德和东工业园的最新资讯、项目进展、投资机会及重要活动。",
    promo_title: "立即咨询投资",
    promo_desc:
      "联系我们获取土地储备详情及投资者专属优惠。",
    promo_btn: "立即联系",
  },
  landingModel: {
    profit: "Profit",
    investment: "Investment",
    ownership: "ownership",
    or: "or",
    authorized: "partner authorized",
    swipe: "Swipe horizontally to view model",
    investor: "INVESTOR",
    returnProfit: "Dividends / Principal return",
    deposit: "Deposit (taybacduchoadong)",
    factory: "Factory",
    others: "Other industries",
    agricultureExport: "Agricultural Export (Viet Thien)",
    startupCo: "Startup Co",
    realEstate: "Real Estate",
  },
  landingProblem: {
    downloadBtn: "Download App Now",
  },
  landingHero: {
    downloadBtn: "Download Now",
  },
  landingSolution: {
    downloadBtn: "Download App Now",
  },
  landingAppExp: {},
  landingProjects: {
    downloadBtn: "Download App Now",
  },
  landingCTA: {
    downloadBtn: "Download Now",
  },
  pdfViewer: {
    titleScript: "查询",
    titleNormal: "区位与规划信息",
    downloadTooltip: "下载 PDF",
    fullscreenTooltip: "全屏查看",
    loadingText: "文档加载中...",
    fileNames: {
      "1": "厂房规划布局图",
      "2": "西北德和东工业园总体规划图",
      "3": "项目品牌宣传册 (Profile)"
    }
  },
  industrialLanding: {
    phone: "098999999999",
    consult: "立即咨询",
    news: {
      titleScript: "新闻",
      titleAmp: " & ",
      titleMain: "活动",
      detailsTitle: "新闻详情"
    },
    contact: {
      btnSubmit: "提交预约",
      btnSending: "发送中...",
      errorSubmit: "提交失败",
      errorSystem: "发生错误，请重试",
      successTitle: "提交成功！",
      successDesc: "感谢您的关注。我们会尽快与您联系。",
      btnClose: "关闭"
    }
  }
};

export default cn;
